<mat-card appearance="outlined" *ngIf="isRedactionEditor" style="display: flex; flex-direction: column; align-items: center; margin-bottom:5px;">
  <button mat-button color="primary" (click)="redactCurrentPageClicked.emit(pageNumber)">Redact Entire Page {{pageNumber}}</button>
</mat-card>
<mat-accordion>
  <mat-expansion-panel *ngFor="let page of pagesAndEdits; trackBy: trackByPageNumber" [expanded]="page.pageNum === pageNumber">
    <mat-expansion-panel-header (click)="goToPage(page.pageNum)">
      <mat-panel-title style="justify-content:space-between">
        <div>Page {{page.pageNum}} </div><div> {{getActiveEditCount(page.edits)}}</div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-table [dataSource]="getEdits(page.edits)" class="mat-elevation-z0" [trackBy]="trackById">
      <!-- Text Column -->
      <ng-container matColumnDef="text">
        <mat-cell *matCellDef="let element" (click)="changeActiveItem(element)" class="column-text">
          <div *ngIf="isRedactionEditor" style="font-weight: bolder; margin-right: 10px;">
            <div *ngIf="element.autoRedactionRuleId; else not_auto"
                 [matTooltip]="element.autoRedactionRule.ruleTitle" [matTooltipPosition]="'left'">A</div>
            <ng-template #not_auto><div>M</div></ng-template>
          </div>
          <div *ngIf="element.clientId !== editItemTextId; else edit_text" class="text-display">
            {{element.text}}
          </div>
          <ng-template #edit_text>
            <mat-form-field style="flex: auto;">
              <input matInput *ngIf="isRedactionEditor" placeholder="Text" (blur)="changeActiveItem(null)" (input)="updateEdit(element)" [(ngModel)]="element.text">
              <textarea matInput *ngIf="!isRedactionEditor" placeholder="Text" (blur)="changeActiveItem(null)" (input)="updateEdit(element)" [(ngModel)]="element.text"></textarea>
            </mat-form-field>
          </ng-template>
        </mat-cell>
      </ng-container>
      <!-- Color Column -->
      <ng-container matColumnDef="color">
        <mat-cell *matCellDef="let element" (click)="openSelect(element)" class="column-color">
          <div *ngIf="element.clientId !== editItemColorId" style="cursor: pointer;">
            <div [style.background-color]="getBackGroundColor(element.highlightColor)" class="color-display"></div>
          </div>
          <mat-form-field style="flex: auto;" *ngIf="element.clientId === editItemColorId">
            <mat-select *ngIf="isRedactionEditor" #redactionColorSelect (selectionChange)="setColor($event, element)" (openedChange)="openChanged($event)" [(value)]="element.highlightColorId">
              <mat-option *ngFor="let color of redactionColors" [value]="color.highlightColorId">
                <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
                  <div>{{getColor(color)}}</div><div [style.background-color]="getBackGroundColor(color.colorValue)" class="color-display-select"></div>
                </div>
              </mat-option>
            </mat-select>
            <mat-select *ngIf="!isRedactionEditor" #annotationColorSelect (selectionChange)="setColor($event, element)" (openedChange)="openChanged($event)" [(value)]="element.highlightColorId" [panelOpen]="element.clientId !== editItemColorId">
              <mat-option *ngFor="let highlightColor of highlightColors" [value]="highlightColor.highlightColorId">
                <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
                  <div>{{getColor(highlightColor)}}</div><div [style.background-color]="getBackGroundColor(highlightColor.colorValue)" class="color-display-select"></div>
                </div>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </mat-cell>
      </ng-container>
      <!-- Delete Column -->
      <ng-container matColumnDef="delete">
        <mat-cell *matCellDef="let element" class="column-delete">
          <button mat-icon-button *ngIf="selectedId === element.clientId" (click)="deleteEdit(element);"><mat-icon>clear</mat-icon></button>
        </mat-cell>
      </ng-container>
      <mat-row *matRowDef="let row; columns: displayColumns;" (mouseenter)="setSelectedEdit(row.clientId)" [ngClass]="{'selected-edit': selectedId === row.clientId}"></mat-row>
    </mat-table>
  </mat-expansion-panel>
</mat-accordion>
